import { Module } from 'vuex';
import { NodeAutoLoginDefinitionState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeAutoLoginDefinitionState = {
    autoLoginDefinitions: undefined,
    autoLoginDefinitionCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const nodeAutoLoginDefinition: Module<NodeAutoLoginDefinitionState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
